import { ComponentProps } from "react";

import Nav from "../Nav";
import { useReport } from "./ReportProvider";

const ReportNav = (props: ComponentProps<typeof Nav>) => {
  const reporting = useReport();
  const area = reporting?.origin?.area;
  const report = area && reporting?.reports[area];

  return (
    <Nav
      {...props}
      prevStep={() => (area ? reporting?.back(area) : reporting?.close())}
      nextStep={() => reporting?.close()}
      // The sent confirmation only offers Continue and Close, and a text-box send can't be left.
      showPrevStep={
        report?.status !== "sent" &&
        !(report?.status === "sending" && report.reason === "other")
      }
    />
  );
};

export default ReportNav;
